import type { OrderFulfillmentStatus, OrderSummary } from '@repo/api-contracts';

/** 고객이 보는 주문 진행 단계 — 주문 고객 화면 이름(getOrderDisplayStatus)의 정상 흐름과 같은 이름이다. */
export const ORDER_PROGRESS_STEPS = [
  '결제 대기',
  '결제 완료',
  '제작 중',
  '배송 중',
  '배송 완료',
] as const;
export type OrderProgressStep = (typeof ORDER_PROGRESS_STEPS)[number];

export interface OrderProgress {
  /** 지금 머문(또는 멈춘) 단계의 순번 — ORDER_PROGRESS_STEPS 기준. */
  readonly currentIndex: number;
  /** 취소·환불로 그 단계에서 끝났는지. */
  readonly ended: boolean;
}

const INDEX_BY_FULFILLMENT: Readonly<Record<OrderFulfillmentStatus, number>> = {
  WAITING: 1,
  IN_PRODUCTION: 2,
  SHIPPED: 3,
  DELIVERED: 4,
};

/**
 * 결제 대기는 첫 단계, 결제한 주문은 진행(fulfillmentStatus)의 단계다. 결제 전 취소는 결제 대기에서, 환불은 환불 때의
 * 진행 단계에서 끝난다(견적 진행 단계와 같은 관례 — 멈춘 단계를 보여 주고 끝났다고 적는다).
 */
export const orderProgressOf = (
  order: Pick<OrderSummary, 'status' | 'fulfillmentStatus'>,
): OrderProgress => {
  if (order.status === 'PENDING_PAYMENT') return { currentIndex: 0, ended: false };
  if (order.status === 'CANCELED') return { currentIndex: 0, ended: true };
  return {
    currentIndex: INDEX_BY_FULFILLMENT[order.fulfillmentStatus],
    ended: order.status === 'REFUNDED',
  };
};
